export class ScreenElementApiModel {
  id: string;

  name: string;

  seatIds: string[];
}
